import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import CustomInput from "../../components/CustomInput";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Auth } from "aws-amplify";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { appLogger, Http } from "../../utils";
import { enableRecaptcha, reCaptchaSiteKey } from "../../utils/config";
import { CheckCaptchValid, reCaptchaMandatoryMessage } from "../../utils/data";
import { UserLoginInfo } from "../../types/context";
import { UserContext } from "../../context/userContext";

const recap_siteKey = reCaptchaSiteKey;
const env = process.env.REACT_APP_STAGE;

const ForgotPassword = (props: any) => {
  const {
    type,
    forgotPassword,
    email,
    user,
    setLoginPage,
    changePasswordModal,
    handleClose,
  } = props;
  appLogger.info({
    infoObj: {
      method: "ForgotPassword",
      component: "home",
      fileName: "ForgotPassword.tsx",
      props: props,
    },
  });

  const test = "true";
  //   if (type == "change") {
  // test =  "true";
  //   }
  const initialValues = {
    password: "",
    confirmPassword: "",
    ConfirmationCode: "",
    oldpassword: "",
  };

  const validationSchema = Yup.object({
    password: Yup.string()
      .min(12, "Password must be at least 12 characters")
      .required("New Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$^*.\[\]{}\(\)\?\-\"\!@#%&\/\\,><\':;|_~`+\=])(?=.{8,20})/, //any of these should be allowed ^$*.[]{}()?-"!@#%&/\,><':;|_~`+=
        "Must Contain 12 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
    ConfirmationCode:
      type == "forgot"
        ? Yup.string().required("verification code is required")
        : Yup.string(),
    oldpassword:
      type == "change"
        ? Yup.string().required("Old password is required")
        : Yup.string(),
  });
  const [newPasswordVisible, setnewPasswordVisible] = useState(false);
  const [oldPasswordVisible, setoldPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [isLoading, setIsloading] = React.useState(false);
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    let script: any;
    const style = document.createElement("style");
    // Define your CSS rules
    const cssRules = `
      .grecaptcha-badge {
        visibility: hidden;
  opacity: 0;
  width: 1px !important;
  height: 1px !important;
      }
    `;

    // Add CSS rules to the style element
    style.appendChild(document.createTextNode(cssRules));

    // Append the style element to the document head
    document.head.appendChild(style);
    const loadScript = () => {
      script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recap_siteKey}`;
      script.async = true;
      script.defer = true;
      script.id = "SignUp";

      script.onload = () => setScriptLoaded(true);
      document.body.appendChild(script);
    };
    loadScript();
    return () => {
      // const scriptElem: any = document.getElementById("SOME_ID");
      // scriptElem.remove();
      if (scriptLoaded) {
        document.body.removeChild(script);
      }
    };
  }, [scriptLoaded]);
  const submiForgotPasswordRequest = async (values: any) => {
    appLogger.info({
      infoObj: {
        method: "submiForgotPasswordRequest",
        component: "home",
        fileName: "ForgotPassword.tsx",
        values: values,
      },
    });
    setIsloading(true);
    if (enableRecaptcha) {
      await window.grecaptcha.enterprise.ready(function () {
        window.grecaptcha.enterprise
          .execute(recap_siteKey, {
            action: "FORGOT_PASSWORD",
          })
          .then(function (token: any) {
            // Handle the reCAPTCHA token
            if (token) {
              setIsloading(true);
              // Call your backend API to verify the reCAPTCHA token
              // Handle the form submission logic here
              Http.post({
                url: `/api/v2/recaptcha`,
                customHeaders: { noauthvalidate: "true" },
                state: userInfo,
                body: {
                  token: token,
                  expectedAction: "FORGOT_PASSWORD",
                },
              })
                .then(async (response: any) => {
                  setIsloading(false);
                  const checkValidData: any = CheckCaptchValid(
                    response?.message
                  );
                  if (checkValidData) {
                    const parsedData = JSON.parse(checkValidData);
                    if (parsedData && parsedData.valid) {
                      confirmsubmiForgotPasswordRequest(values);
                    } else {
                      props.snackbarShowMessage(
                        "Captcha verification failed",
                        "error"
                      );
                    }
                  } else {
                    props.snackbarShowMessage(
                      "Captcha verification failed",
                      "error"
                    );
                  }
                })
                .catch((error: any) => {
                  appLogger.error({
                    errObj: {
                      method: "regenerateApiKey",
                      component: "login",
                      fileName: "home.tsx",
                      err: error,
                    },
                  });
                  setIsloading(false);
                });
            } else {
              props.snackbarShowMessage("Captcha verification failed");
              setIsloading(false);
            }
          })
          .catch(function (error: any) {
            setIsloading(false);
            props.snackbarShowMessage("Error executing reCAPTCHA:", "error");
          });
      });
    } else {
      confirmsubmiForgotPasswordRequest(values);
    }
  };
  const confirmsubmiForgotPasswordRequest = (values: any) => {
    Auth.forgotPasswordSubmit(
      email.value,
      values.ConfirmationCode,
      values.confirmPassword
    )
      .then((response) => {
        appLogger.info({
          infoObj: {
            method: "submiForgotPasswordRequest",
            component: "home",
            fileName: "ForgotPassword.tsx",
            response: response,
          },
        });
        props.snackbarShowMessage("Password Reset Successfully", "success");
        setIsloading(false);
        setLoginPage();
      })
      .catch((e) => {
        appLogger.error({
          errObj: {
            method: "submiForgotPasswordRequest",
            component: "home",
            fileName: "ForgotPassword.tsx",
            err: e,
          },
        });
        // notifyError(e.message);
        setIsloading(false);
        props.snackbarShowMessage(e.message, "error");
        setTimeout(function () {
          setLoginPage();
        }, 2000);
      });
  };
  const submitChangePassword = async (values: any) => {
    setIsloading(true);
    appLogger.info({
      infoObj: {
        method: "submitChangePassword",
        component: "home",
        fileName: "ForgotPassword.tsx",
        values: values,
      },
    });
    if (enableRecaptcha) {
      await window.grecaptcha.enterprise.ready(function () {
        window.grecaptcha.enterprise
          .execute(recap_siteKey, {
            action: "CHANGE_PASSWORD",
          })
          .then(function (token: any) {
            // Handle the reCAPTCHA token
            if (token) {
              setIsloading(true);
              // Call your backend API to verify the reCAPTCHA token
              // Handle the form submission logic here
              Http.post({
                url: `/api/v2/recaptcha`,
                customHeaders: { noauthvalidate: "true" },
                state: userInfo,
                body: {
                  token: token,
                  expectedAction: "CHANGE_PASSWORD",
                },
              })
                .then(async (response: any) => {
                  setIsloading(false);
                  const checkValidData: any = CheckCaptchValid(
                    response?.message
                  );
                  if (checkValidData) {
                    const parsedData = JSON.parse(checkValidData);
                    if (parsedData && parsedData.valid) {
                      confirmsubmitChangePassword(values);
                    } else {
                      props.snackbarShowMessage(
                        "Captcha verification failed",
                        "error"
                      );
                    }
                  } else {
                    props.snackbarShowMessage(
                      "Captcha verification failed",
                      "error"
                    );
                  }
                })
                .catch((error) => {
                  appLogger.error({
                    errObj: {
                      method: "regenerateApiKey",
                      component: "login",
                      fileName: "home.tsx",
                      err: error,
                    },
                  });
                  setIsloading(false);
                });
            } else {
              props.snackbarShowMessage("Captcha verification failed");
              setIsloading(false);
            }
          })
          .catch(function (error: any) {
            props.snackbarShowMessage("Error executing reCAPTCHA:", "error");
            setIsloading(false);
          });
      });
    } else {
      confirmsubmitChangePassword(values);
    }
  };
  const confirmsubmitChangePassword = (values: any) => {
    setIsloading(true);
    Auth.currentAuthenticatedUser()
      .then((user) => {
        return Auth.changePassword(
          user,
          values.oldpassword,
          values.confirmPassword
        );
      })
      .then((response) => {
        setIsloading(false);
        props.snackbarShowMessage("Password Changed Successfully", "success");
        setTimeout(function () {
          handleClose(false);
        }, 2000);
      })
      .catch((e) => {
        appLogger.error({
          errObj: {
            method: "submitChangePassword",
            component: "home",
            fileName: "ForgotPassword.tsx",
            err: e,
          },
        });
        setIsloading(false);
        props.snackbarShowMessage(e.message, "error");
      });
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      try {
        appLogger.info({
          infoObj: {
            method: "useFormik",
            component: "home",
            fileName: "ForgotPassword.tsx",
            value: { values, email, user },
          },
        });
        if (type == "forgot") {
          submiForgotPasswordRequest(values);
        } else {
          submitChangePassword(values);
        }
      } catch (error) {
        appLogger.error({
          errObj: {
            method: "useFormik",
            component: "home",
            fileName: "ForgotPassword.tsx",
            err: error,
          },
        });
      }
    },
  });

  const handleClickShowPassword = () => {
    setnewPasswordVisible(!newPasswordVisible);
  };
  const handleClickShowOldPassword = () => {
    setoldPasswordVisible(!oldPasswordVisible);
  };

  const handleConfirmPassword = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  return (
    <>
      <Box
        className={isLoading ? " chart-item loader form-wrap" : "form-wrap "}
      >
        <Typography component="h1" variant="h5">
          {type == "forgot" ? "Forgot Password" : "Change Password"}
        </Typography>
        {type == "forgot" && (
          <p className="forget-email-success">
            We have sent a password reset code by email. Enter it below to reset
            your password
          </p>
        )}
        <Typography component="h5" sx={{ mb: "10px" }}>
          Enter your new password below
        </Typography>
        {/* {errorMsg != "" && (
        <Typography className="error-msg">{errorMsg}</Typography>
      )}
      {successMsg != "" && (
        <Typography className="success-msg">{successMsg}</Typography>
      )} */}
        <Box
          component="form"
          onSubmit={formik.handleSubmit}
          method="post"
          noValidate
          sx={{ mt: "20px" }}
        >
          {type == "forgot" && (
            <CustomInput
              placeholder="Verification Code"
              label="Verification Code"
              type="text"
              id="ConfirmationCode"
              startAdornment={
                <InputAdornment position="start">
                  <LockOpenIcon />
                </InputAdornment>
              }
              {...formik.getFieldProps("ConfirmationCode")}
              error={
                formik.touched.ConfirmationCode &&
                formik.errors.ConfirmationCode
                  ? true
                  : false
              }
              helperText={
                formik.touched.ConfirmationCode &&
                formik.errors.ConfirmationCode
                  ? formik.errors.ConfirmationCode
                  : null
              }
            />
          )}
          {type == "change" && (
            <CustomInput
              placeholder="Old Password"
              label="Old Password"
              type={oldPasswordVisible ? "text" : "password"}
              id="oldpassword"
              autoComplete="old-password"
              startAdornment={
                <InputAdornment position="start">
                  <LockOpenIcon />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowOldPassword}
                    edge="end"
                  >
                    {newPasswordVisible ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              {...formik.getFieldProps("oldpassword")}
              error={
                formik.touched.oldpassword && formik.errors.oldpassword
                  ? true
                  : false
              }
              helperText={
                formik.touched.oldpassword && formik.errors.oldpassword
                  ? formik.errors.oldpassword
                  : null
              }
            />
          )}
          <CustomInput
            placeholder="New Password"
            label="New Password"
            type={newPasswordVisible ? "text" : "password"}
            id="password"
            autoComplete="new-password"
            startAdornment={
              <InputAdornment position="start">
                <LockOpenIcon />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {newPasswordVisible ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            {...formik.getFieldProps("password")}
            error={
              formik.touched.password && formik.errors.password ? true : false
            }
            helperText={
              formik.touched.password && formik.errors.password
                ? formik.errors.password
                : null
            }
          />
          {/* <FormHelperText id='outlined-weight-helper-text'>
					Weight
					</FormHelperText> */}

          <CustomInput
            placeholder="Confirm Password"
            label="Confirm Password"
            type={confirmPasswordVisible ? "text" : "password"}
            id="confirmPassword"
            autoComplete="new-password"
            startAdornment={
              <InputAdornment position="start">
                <LockOpenIcon />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleConfirmPassword}
                  edge="end"
                >
                  {confirmPasswordVisible ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            {...formik.getFieldProps("confirmPassword")}
            error={
              formik.touched.confirmPassword && formik.errors.confirmPassword
                ? true
                : false
            }
            helperText={
              formik.touched.confirmPassword && formik.errors.confirmPassword
                ? formik.errors.confirmPassword
                : null
            }
          />
          {reCaptchaMandatoryMessage()}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: "15px",
              mb: "15px",
              backgroundColor: (theme: any) => theme.palette.primary.main,
              textTransform: "uppercase",
            }}
          >
            Send
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default withSnackbar(ForgotPassword);
